module.exports = __webpack_public_path__ + "img/ub.d15378de.png";